/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    baseStyle: {
        container: {
            paddingTop: 4,
            paddingBottom: 4,
            paddingLeft: [4, 4, 6, 6, 8],
            paddingRight: [4, 4, 6, 6, 8],
        },
        icon: {
            height: 5,
            width: 5,
        },
        message: {
            paddingLeft: 2,
            fontWeight: 700,
        },
    },
    parts: ['container', 'icon', 'message'],
};
